import type { ResponseDto } from '@app/api/dtos'
import type { ExternalProductsSearchListItemDto } from '@app/api/routes/externalProductsCatalog/dtos'
import type { ExternalSearchProductsListDataSource } from '@app/types/dataSource'

export const getExternalProductsSearchListFromResponse = (
  response?: ResponseDto<ExternalProductsSearchListItemDto>
): ExternalSearchProductsListDataSource[] | undefined => {
  if (!response) return

  const rawData: ExternalProductsSearchListItemDto[] | undefined = response.results

  if (!rawData) return

  return rawData.map(dto => ({
    key: dto.id,
    code: dto.code ?? dto.id,
    name: dto.name,
    trend: dto?.trend?.name ?? '',
    purchasingGroup: dto?.purchasingGroup?.name ?? '',
    commodityGroup: dto?.commodityGroup?.name ?? '',
    category: dto?.category?.name ?? '',
    subcategory: dto?.subcategory?.name ?? '',
    barcodes: dto.barcodes?.join(' ') ?? ''
  }))
}
